// from general.js
/* global isMobileView isTeacherUserPage Uri getTrackingLink */
// from JSP?
/* global userObj teacherId teacherName */

import '../../../external/jquery/jquery.sticky.js';
import './teacherClassroomPhoto.js'; // for onclick handler
import './trackBirthdayBanner.js'; // for doc ready handler
import './trackTeacherPageStatus.js'; // for doc ready handler
import './teacherCookies.js'; // for doc ready handler
import '../../faq/faq.js'; // for doc listeners
import '../../sharebar/shareBarOnClickHandlers.js'; // for doc listeners
import { addOrRemoveFavorite } from '../../follow/follow.js';
import { editVanityURL } from '../../vanityurl/vanityURL.js';
import { requireLoginForPageUpdate } from '../../utils/userUtils.js';
import { getDonateOptions } from './teacherDonateBar.js';
import { toggleDonateOptions } from '../../donateBar/floatingDonateBar.js';
import {
    validateInspireForm,
    validateQuickDonation,
    validateRecurringDonationForm,
} from '../../giveWidget/giveWidgetFunctions.js';

$(function () {
    $(document).ready(function () {
        showExistingRecurringDonationAlert();
    });

    $('.js-vanity-url-link').on('click', () => editVanityURL(requireLoginForPageUpdate));

    function showExistingRecurringDonationAlert() {
        if (userObj && userObj.hasActiveRecurringDonation === true) {
            if (isMobileView()) {
                $('#mobileDonateBar .js-choose-once').click();
            } else {
                $('#desktopDonateBar .js-choose-once').click();
            }
            $('.existing-recurring-donation').show();
        }
    }

    if (isTeacherUserPage()) {
        const urlObj = new Uri(location.href);
        const hasRFParam = urlObj.getParam('rf');
        if (!hasRFParam) {
            history.replaceState(null, null, decodeURIComponent(getTrackingLink(location.href, 'page')));
        }
    }

    $('.js-quick-donate-form').on('submit', function () {
        return validateQuickDonation($('.js-quick-donate-form')[0]);
    });
    $('.js-inspire-form').on('submit', function () {
        return validateInspireForm($('.js-inspire-form')[0]);
    });
    $('.js-mobile-recurring-donation-form').on('submit', function () {
        return validateRecurringDonationForm($('.js-mobile-recurring-donation-form')[0]);
    });
    $('.js-desktop-recurring-donation-form').on('submit', function () {
        return validateRecurringDonationForm($('.js-desktop-recurring-donation-form')[0]);
    });
    // Long-term, we should migrate this to use the FavoriteHeart React component
    // That would be difficult right now because that component is an ES6 module,
    // and this page has complex compilation with various module types.
    $('.js-classroom-updates').on('click', function (e) {
        addOrRemoveFavorite(teacherId, 'teacherId', this.id, 'fav-teacher-link', teacherName);
        e.preventDefault();
    });

    $('.js-choose-monthly').on('click', function (e) {
        e.preventDefault();
        if (!$('.js-choose-monthly').hasClass('active')) {
            toggleDonationType();
            // hide donation options if switching back to monthly
            if ($('#donateOptions').hasClass('on')) {
                toggleDonateOptions();
            }
        }
    });

    $('.js-choose-once').on('click', function (e) {
        e.preventDefault();
        // only get options on mobile
        if ($(e.target).parents('#mobileDonateBar').length > 0) {
            getDonateOptions();
        }
        if (!$('.js-choose-once').hasClass('active')) {
            toggleDonationType();
        }
    });

    function toggleDonationType() {
        $('.js-give-monthly').toggleClass('active');
        $('.js-give-once').toggleClass('active');
        $('.js-choose-once').toggleClass('active');
        $('.js-choose-monthly').toggleClass('active');
        $('#desktopDonateBar').toggleClass('one-time-chosen');
        $('#mobileDonateBar').toggleClass('one-time-chosen');
    }
});
